import Auth_API from "./apiConfig";
const handleError = (error) => {
  if (error.response) {
    console.error("Server Error:", error.response.data.message || error.response.statusText);
    throw new Error(error.response.data.message || "Server Error");
  } else if (error.request) {
    console.error("Network Error:", error.message);
    throw new Error("Network Error. Please check your connection.");
  } else {
    console.error("Error:", error.message);
    throw new Error("An unexpected error occurred. Please try again.");
  }
};

export const getUserProfile = async (userId) => {
  try {
    const response = await Auth_API.get(`/user/getUser/${userId}`);
    return response.data;

  } catch (error) {
    // Check if the error is from the server
    if (error.response) {
      // Server responded with a status other than 2xx
      console.error("Server Error:", error.response.data.message || error.response.statusText);
      throw new Error(error.response.data.message || "Server Error");
    } else if (error.request) {
      // Request was made but no response was received
      console.error("Network Error:", error.message);
      throw new Error("Network Error. Please check your connection.");
    } else {
      // Something else happened while setting up the request
      console.error("Error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
};

export const markNotificationAsRead = async (notificationId) => {
  try {
    const response = await Auth_API.put(`/notifications/read?notification_id=${notificationId}`);
    return response.data;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    const message = error.response?.data?.message || error.message;
    throw new Error(message);
  }
};

export const markNotificationAsReadAPI = async (notificationId) => {
  try {
    const response = await Auth_API.put(`/notifications/read?notification_id=${notificationId}`);
    return response.data;
  } catch (error) {
    console.error("Error marking notification as read:", error);
    const message = error.response?.data?.message || error.message;
    throw new Error(message);
  }
}

export const getAllNotifications = async (params) => {
  try {
    const response = await Auth_API.get('/user/notifications', { params });
    return response.data;
  }
  catch (error) {
    if (error.response) {
      console.error("Server Error:", error.response.data.message || error.response.statusText);
      throw new Error(error.response.data.message || "Server Error");
    } else if (error.request) {
      console.error("Network Error:", error.message);
      throw new Error("Network Error. Please check your connection.");
    } else {
      console.error("Error:", error.message);
      throw new Error("An unexpected error occurred. Please try again.");
    }
  }
}

export const udpateTermsAndCondition = async (params) => {
  try {
    const response = await Auth_API.post('/user/accept-terms_conditions', params);
    return response.data;
  }
  catch (error) {
    if (error.response) {
      console.error("Server Error:", error.response.data.message || error.response.statusText);
      throw new Error(error.response.data.message || "Server Error");
    } else if (error.request) {
      console.error("Network Error:", error.message);
      throw new Error("Network Error. Please check your connection.");
    } else {
      console.error("Error:", error.message);
      throw new Error("An unexpected error occurred. Please try again."
        
      );
    }
  }
}

export const getUserPosts = async (id, page, limit) => {
  try {
    const response = await Auth_API.get(`/post/user/${id}`, {
      params: { page, limit }, // ✅ this sends query parameters
    });
    return response.data;
  } catch (error) {
    handleError(error);
  }
};


export const getZoomMeeting = async (params) => {
  try {
    const response = await Auth_API.post('/zoom/join-meeting', params);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

export const checkUserEmail = async (email) => {
  try {
    const response = await Auth_API.post(`/kyc/check?email=${email}`);
    return response;
  } catch (error) {
    handleError(error);
  } 
}

export const deleteUserBlockers = async () => {
  try {
    const response = await Auth_API.get(`/user/account/deletion/blockers`);
    return response.data;
  } catch (error) {
    handleError(error);
  }
}

export const deleteUserRequest = async (params) => {
  try {
    const response = await Auth_API.post('/user/account/deletion/request', params);
    return response.data;
  } catch (error) {
    handleError(error);
  }
}

